"use client";

import React from "react";
import styled from "styled-components";
import { VISIBLE_TIME_OUT } from "@/components/constants";
import Button from "@/components/common/Button";

// ✅ Redux
import { useDispatch, useSelector } from "react-redux";
import { clearConfirm } from "@/redux/confirm/ConfirmActions"; // 아까 만든 thunk

const Confirm = () => {
    const dispatch = useDispatch();
    const { visible, content } = useSelector((state) => state.confirm);

    const clickContainer = (e) => {
        e.stopPropagation();
    };

    return (
        <Dimmer
            className={`${visible ? "on" : ""}`}
        >
            <ConfirmContainer
                className={`confirm-container flex jc-end al-center fd-column`}
                onClick={clickContainer}
                $transition={VISIBLE_TIME_OUT}
            >
                <TextWrap>
                    <div className={"text-area"}>
                        {content.title && (
                            <ConfirmHeadContent>
                                <p dangerouslySetInnerHTML={{ __html: content.title }} />
                            </ConfirmHeadContent>
                        )}
                        {content.text && (
                            <ConfirmBodyContent>
                                <p dangerouslySetInnerHTML={{ __html: content.text }} />
                            </ConfirmBodyContent>
                        )}
                    </div>
                </TextWrap>

                <div className={"btn-wrap gap-10 flex al-center"}>
                    {content.cancelText && (
                        <Button
                            type="solid"
                            size="l"
                            full={true}
                            text={`${content.cancelText}`}
                            round={true}
                            onClickFunc={() => {
                                // cancelFunc 우선, 없으면 closeFunc, 둘 다 없으면 clear
                                if (content.cancelFunc) content.cancelFunc(() => dispatch(clearConfirm()));
                                else if (content.closeFunc) content.closeFunc(() => dispatch(clearConfirm()));
                                else dispatch(clearConfirm());
                            }}
                        />
                    )}

                    <Button
                        type="fill"
                        size="l"
                        full={true}
                        text={`${content.confirmText}`}
                        round={true}
                        onClickFunc={() => {
                            // confirmFunc 실행 후 닫기 콜백 전달 (기존 패턴 유지)
                            if (content.confirmFunc) content.confirmFunc(() => dispatch(clearConfirm()));
                            else dispatch(clearConfirm());
                        }}
                    />
                </div>
            </ConfirmContainer>
        </Dimmer>
    );
};

const TextWrap = styled.div`
    height: 100%;
    width: 100%;
    position: relative;
`;
const Dimmer = styled.div`
    position: fixed;
    z-index: 150;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.1s ease;
    opacity: 0;
    visibility: hidden;

    &.on {
        opacity: 1;
        visibility: visible;

        .confirm-container {
            opacity: 1;
        }
    }
`;

const ConfirmContainer = styled.article`
    min-width: 150px;
    height: 60px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.08), 0px 4px 16px -4px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    overflow: hidden;
    padding: 40px 20px 20px;
    background-color: #fff;
    text-align: center;
    transition: ${(props) => `all ${props.$transition / 1000}s ease-in-out`};
    opacity: 0;
    position: relative;

    .text-area {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }

    .btn-wrap {
        width: 100%;
    }
`;

const ConfirmHeadContent = styled.div`

    padding: 0 0 10px;

    p {
        white-space: pre-line;
    }
`;

const ConfirmBodyContent = styled.div`


    p {
        white-space: pre-line;
    }
`;

export default Confirm;
